/**
 * Contains all imports of external CSS libs (.css files) that must be injected in all Next.js pages.
 *
 * This approach is preferred over importing them all one by one within the _app.tsx file, because it's easier to maintain.
 *
 * Also, this file is being imported by both "src/pages/_app.tsx" and ".storybook/preview.js",
 * so that global 3rd party CSS are included when previewing components, too.
 */

import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './tailwind.css';
import './globals.css';
import './fonts.css';
import './precision.css';

export {};
